import SlideHeader from './lib/components/SlideHeader';

const DEFINITIONS = [
  {
    term: 'Good Faith Estimate POL (GFE)',
    definition:
      'An estimate of what your medical services will cost, given to you before your visit so there are no surprises on your bill.'
  },
  {
    term: 'No Surprises Act',
    definition:
      'A federal law that protects you from unexpected medical bills — especially from out-of-network care — by limiting what you can be charged and requiring upfront cost estimates.'
  },
  {
    term: 'Live Eligibility Information',
    definition:
      "Real-time info from your insurance about your current coverage and benefits — what they'll pay for and how much of your deductible or out-of-pocket max you've used so far."
  },
  {
    term: 'Covered Service',
    definition: 'Any treatment or procedure your insurance plan helps pay for.'
  },
  {
    term: 'Yearly or Lifetime Maximum',
    definition:
      'The most your plan will pay for covered services in a year (yearly maximum) or over the life of the policy (lifetime maximum). Once you hit it, you cover any extra costs.'
  },
  {
    term: 'Deductible',
    definition:
      'The amount you pay out of pocket each year for healthcare before your insurance starts sharing the cost. For example, if your deductible is $1,500, you pay the first $1,500 of covered care yourself.'
  },
  {
    term: 'Coinsurance',
    definition:
      "Your share of the bill after you've met your deductible — usually a percentage. With 20% coinsurance, you pay $20 for every $100 of covered care, and your insurance pays the other $80."
  },
  {
    term: 'Copayment',
    definition:
      'A flat fee you pay at the time of your visit — like $25 for a checkup — set by your insurance plan.'
  },
  {
    term: 'Out-of-Pocket Max',
    definition:
      "The yearly cap on what you'll pay out of pocket for covered services. Once you hit it, your insurance covers 100% of the rest for the year."
  },
  {
    term: 'Allowed Amount',
    definition:
      "The maximum your insurance has agreed to pay for a service. Anything the provider charges above this gets written off — you don't pay the difference."
  }
];

const DefinitionsPage = () => (
  <div className="flex flex-col gap-5">
    <SlideHeader title="Definitions" />

    <div className="flex flex-col gap-3">
      {DEFINITIONS.map((item) => (
        <div key={item.term}>
          <span className="mb-1 inline-block rounded-lg bg-gradient-to-r from-[#00B8E8] to-[#4DD4F0] px-3 py-1">
            <span className="text-sm font-700 uppercase tracking-wider text-white">
              {item.term}
            </span>
          </span>
          <p className="text-sm leading-relaxed text-neutral-700">{item.definition}</p>
        </div>
      ))}
    </div>
  </div>
);

export default DefinitionsPage;
